import { stat, normalStat } from '@/utils/stat'

export default (context, inject) => {
  inject('stat', normalStat) // Vue实例、组件、store的actions/mutations，引入 $stat
  inject('statDetail', stat)
}
